export const REQUEST_STATISTICS_LOG = 'statistics/REQUEST_STATISTICS_LOG' as const;
export const REQUEST_STATISTICS_LOG_SUCCESS = 'statistics/REQUEST_STATISTICS_LOG_SUCCESS' as const;
export const REQUEST_STATISTICS_LOG_FAILURE = 'statistics/REQUEST_STATISTICS_LOG_FAILURE' as const;
